export default "__VITE_ASSET__989ba56b__"